import imgTipCollage from '../assets/tools/collage.png';
import imgTipChangeFace from '../assets/tools/changeface.png';
import imgTipCutout from '../assets/tools/cutout.png';
import imgTipInpaint from '../assets/tools/inpaint.png';
import imgTipOutpaint from '../assets/tools/outpaint.png';
import imgTipUpscale from '../assets/tools/upscale.png';
import imgTipCrop from '../assets/tools/crop.png';
import imgTipRemoveSmart from '../assets/tools/smartRemove.png';
import imgTipColorAdjustment from '../assets/tools/colorAdjustment.png';
import iconInpaint from '../assets/tools/inpaint.svg';
import iconUpscale from '../assets/tools/upscale.svg';
import iconOutpaint from '../assets/tools/outpaint.svg';
import iconCutout from '../assets/tools/cutout.svg';
import iconCrop from '../assets/tools/crop.svg';
import iconRemoveSmart from '../assets/tools/smartRemove.svg';
import iconChangeFace from '../assets/tools/changeface.svg';
import iconColorAdjustment from '../assets/tools/colorAdjustment.svg';
import iconSelectAreaTool from '../assets/tools/selectAreaTool.svg';
import imgTipSelectAreaTool from '../assets/tools/selectAreaTool.png';

export const generatingStatus = { pending: true, queueing: true, generating: true };
export const toolSampleImages = {
  inpaint: imgTipInpaint,
  upscale: imgTipUpscale,
  outpaint: imgTipOutpaint,
  removeBackground: imgTipCutout,
  crop: imgTipCrop,
  smartRemove: imgTipRemoveSmart,
  collage: imgTipCollage,
  changeFace: imgTipChangeFace,
  colorAdjustment: imgTipColorAdjustment,
  selectAreaTool: imgTipSelectAreaTool,
};

export const toolIcons = {
  inpaint: iconInpaint,
  upscale: iconUpscale,
  outpaint: iconOutpaint,
  removeBackground: iconCutout,
  crop: iconCrop,
  smartRemove: iconRemoveSmart,
  changeFace: iconChangeFace,
  colorAdjustment: iconColorAdjustment,
  selectAreaTool: iconSelectAreaTool,
};

// 目前只用到了name，根据后期能力扩展在加字段
export const toolTypes = {
  outpaint: {
    name: 'outpaint',
  },
  upscale: {
    name: 'upscale',
  },
  inpaint: {
    name: 'inpaint',
  },
  selectAreaTool: {
    name: 'selectAreaTool',
  },
};
